<micro-select-combo #sel
              placeholder="HTTP Method"
              [mode]="mode"
              [(id)]="method"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
              [blur]="onTouched">
</micro-select-combo>
